module.exports = __webpack_public_path__ + "static/Meditate-b1bfc42d6acfb32e531835abe32af669.png";